import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { camelCase, capitalize, mergeProps } from './utils';
import * as Icons from './icons';
import styles from './iconography.module.scss';

export default function Icon(props) {
  const { src, IconsSource = Icons, verticalAlign, externalIconClassName, ...others } = props;
  const iconProps = mergeProps(others, {
    className: cx(styles.icon, styles[`icon${capitalize(verticalAlign)}`]),
  });

  const iconSrc = src;
  const renderedIcon = IconsSource[iconSrc];

  // if (!renderedIcon) {
  //   renderedIcon = Icons.help;
  //   iconSrc = 'help';
  //   console.warn(`Icon "${src}" is not recognized.`);
  // }

  let iconClassName = styles[`icon${capitalize(camelCase(iconSrc))}`];
  if (externalIconClassName) iconClassName += ` ${externalIconClassName}`;
  return <div {...iconProps}>{React.cloneElement(renderedIcon, { className: iconClassName, key: iconSrc })}</div>;
}

Icon.propTypes = {
  externalIconClassName: PropTypes.string,
  size: PropTypes.string,
  src: PropTypes.string.isRequired,
  verticalAlign: PropTypes.oneOf(['middle', 'baseline']),
};

Icon.defaultProps = {
  size: 'inherit',
  verticalAlign: 'middle',
};
